import { useCallback, useEffect, useState } from 'react'
import { differenceInSeconds } from 'date-fns'

const useTimer = (startTime, deadline) => {
  const ONE_DAY = 60 * 60 * 24
  const ONE_HOUR = 60 * 60
  const ONE_MINUTE = 60

  const [countDown, setCountDown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    initialized: false,
    expired: true,
  })

  const initializeTimer = useCallback(
    () =>
      setCountDown((s) => ({
        ...s,
        initialized: true,
      })),
    []
  )

  const setCurrentCountDown = useCallback(
    (currentTime) => {
      const diffInSecondsFromStart = differenceInSeconds(
        currentTime,
        new Date(startTime)
      )
      const diffInSeconds = differenceInSeconds(new Date(deadline), currentTime)

      if (
        !diffInSecondsFromStart ||
        diffInSecondsFromStart <= 1 ||
        !diffInSeconds ||
        diffInSeconds <= 1
      ) {
        setCountDown((s) => ({
          ...s,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          expired: true,
        }))
      } else {
        const days = Math.floor(diffInSeconds / ONE_DAY)
        const hours = Math.floor((diffInSeconds - days * ONE_DAY) / ONE_HOUR)
        const minutes = Math.floor(
          (diffInSeconds - days * ONE_DAY - hours * ONE_HOUR) / ONE_MINUTE
        )
        setCountDown((s) => ({
          ...s,
          days,
          hours,
          minutes,
          seconds:
            diffInSeconds -
            days * ONE_DAY -
            hours * ONE_HOUR -
            minutes * ONE_MINUTE,
          expired: false,
        }))
      }
    },
    [ONE_DAY, ONE_HOUR, deadline, startTime]
  )

  useEffect(() => {
    if (!countDown.initialized) {
      return
    }

    const currentTime = new Date()

    const secondsRemainingToMinute =
      (ONE_MINUTE - currentTime.getSeconds()) * 1000

    setCurrentCountDown(currentTime)

    let interval
    const timeout = setTimeout(() => {
      setCurrentCountDown(new Date())
      interval = setInterval(
        () => setCurrentCountDown(new Date()),
        ONE_MINUTE * 1000
      )
    }, secondsRemainingToMinute)
    return () => {
      clearTimeout(timeout)
      clearInterval(interval)
    }
  }, [countDown.initialized, setCurrentCountDown])

  return { countDown, initializeTimer }
}

export default useTimer
